import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconClock = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={16}
      fill="none"
      viewBox="0 0 15 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M8.13838 3.10508C8.13838 2.80922 7.89854 2.56937 7.60267 2.56937C7.3068 2.56937 7.06696 2.80922 7.06696 3.10508V8.04944C7.06696 8.19574 7.12679 8.33568 7.23257 8.43675L9.625 10.7228C9.8389 10.9273 10.178 10.9195 10.3824 10.7056C10.5868 10.4917 10.5791 10.1526 10.3652 9.94822L8.13838 7.82037V3.10508Z"
        fill="currentColor"
      />
      <path
        d="M7.5 15.5C11.6421 15.5 15 12.1421 15 8C15 3.85786 11.6421 0.5 7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5ZM13.9286 8C13.9286 11.5504 11.0504 14.4286 7.5 14.4286C3.9496 14.4286 1.07143 11.5504 1.07143 8C1.07143 4.4496 3.9496 1.57143 7.5 1.57143C11.0504 1.57143 13.9286 4.4496 13.9286 8Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
